module.exports = "\r\n.content.theme-blue .side-nav, .content.theme-blue .theme-toolbar{\r\n    background-color:#292955;\r\n    border-bottom: 1px solid #292955;\r\n}\r\n.content.theme-blue .theme-toolbar{\r\n    color: white;\r\n}\r\n.content.theme-blue .form-group label, .footer{\r\n    color: #292955 !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/Lead/lead-form/lead-form.component.css
// module id = ./src/app/Pages/Lead/lead-form/lead-form.component.css
// module chunks = main